import React, { useEffect, useState } from 'react';
import { Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import styled from 'styled-components';
import ListPanel from '@/components/ListPanel';
import useTable from '@/hooks/useTable';
import { getProxyDetectedResult } from '@/services/maintenanceInspectService';
import { renderDateTime, renderStatusOptions, renderTimeUnit } from '@/utils/common';

export default function ProxyDetected() {
  const [proxyOpen, setProxyOpen] = useState(true); // 是否开启代理

  const columns = [
    {
      title: '环境名称',
      colKey: 'envName',
      fixed: 'left',
      width: 180,
    },
    {
      title: '代理名称',
      colKey: 'proxyName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '代理地址',
      colKey: 'proxyAddress',
      width: 200,
      ellipsis: true,
    },
    {
      title: '状态',
      colKey: 'status',
      options: [
        { label: '正常', value: 'up', status: 'Success' },
        { label: '异常', value: 'down', status: 'Error' },
      ],
      cell: renderStatusOptions,
      width: 120,
    },
    {
      title: '错误信息',
      colKey: 'errMsg',
      ellipsis: true,
    },
    {
      title: '探测花费时间',
      colKey: 'detectedCostTime',
      cell: renderTimeUnit,
      width: 120,
    },
    {
      title: '最后一次探测',
      colKey: 'lastDetectedTime',
      cell: renderDateTime,
      width: 190,
    },
  ];

  const loadData = useMemoizedFn(async () => {
    const { data } = await getProxyDetectedResult();
    const array = [];
    if (data.resultsMap) {
      for (const key in data.resultsMap) {
        const element = data.resultsMap[key];
        array.push(element);
      }
    }
    setData(array);
    setProxyOpen(data.openProxy);
  });

  const { header, config, setData, doSearch } = useTable({
    onSearch: loadData,
    columns,
    append: !proxyOpen && <ProxyStatus>未开启代理</ProxyStatus>,
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  return (
    <ListPanel header='代理检测'>
      {header}
      <Table {...config} />
    </ListPanel>
  );
}

const ProxyStatus = styled.div`
  color: var(--td-error-color);
  flex: 1;
  line-height: 34px;
  padding-left: 4px;
`;
